// extracted by mini-css-extract-plugin
export var option = "_5f-1";
export var optionActive = "_5f-2";
export var pill = "_5f-0";